import { render } from "./main.vue?vue&type=template&id=ba8a7eaa"
import script from "./main.vue?vue&type=script&lang=ts"
export * from "./main.vue?vue&type=script&lang=ts"

import "./main.vue?vue&type=style&index=0&id=ba8a7eaa&lang=scss"
script.render = render

export default script